import { useNavigate, useParams } from "react-router-dom"
import useTargetStorage from "@/hooks/useTargetStorage"
import { useTranslation } from "react-i18next"
import EditProductForm from "features/storages/products/editProductForm"
import Section from "components/layout/section"
import SectionHeader from "components/layout/sectionHeader"
import SectionHeaderTitle from "components/layout/sectionHeaderTitle"
import PageTitle from "features/navigation/pageTitle"
import useProducts from "hooks/useProducts"
import useStorages from "hooks/useStorages"
import { paramGuardStorage, paramGuardProduct } from "@/utils/paramGuard"
import { FormStatus } from "@/types"
import Tag from "@/components/tags/tag"
import RightSidebar from "@/components/sidebar/right/RightSidebar"
import { MainSheetHeaderActions } from "@/components/layout/layoutChrome"

const EditProductPage = () => {

    const { t } = useTranslation()
    const navigate = useNavigate()

    const { targetStorageDocId: storageId } = useTargetStorage()
    const { productId } = useParams<{ productId: string }>()

    const { 
        product,
        productStatus 
    } = useProducts({ storageId, productId })
    const { 
        storage,
        storageStatus 
    } = useStorages({ storageId })

    // Check params and declare safe ones to use in JSX
    if (
        !paramGuardStorage({storageId, storage, storageStatus, navigate}) ||
        !paramGuardProduct({storageId, productId, product, productStatus, navigate})
    ) {
        return <></>
    }
    const safeStorageId = storageId!;
    const safeProductId = productId!;

    // Return the JSX.
    return (
        <>
            <PageTitle title={t('titleEditProduct')} />
            <MainSheetHeaderActions>
                {product?.isDraft && <Tag colorScheme="yellow">{t('tagDraft')}</Tag>}
            </MainSheetHeaderActions>
            <EditProductForm storageId={safeStorageId} productId={safeProductId} />
            <RightSidebar storageId={safeStorageId} />
        </>
    )
}

export default EditProductPage